import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import './Header.css';

const Header: React.FC = () => {
  const { cartItems } = useCart();
  
  const totalItems = cartItems.reduce((total, item) => total + item.quantity, 0);

  return (
    <header className="header">
      <div className="container">
        <div className="logo">
          <Link to="/">Pék Gidi</Link>
        </div>
        <nav className="nav">
          <ul>
            <li>
              <Link to="/">Főoldal</Link>
            </li>
            <li>
              <Link to="/products">Termékek</Link>
            </li>
            <li>
              <Link to="/faqs">GYIK</Link>
            </li>
            <li>
              <Link to="/order" className="cart-link">
                Kosár {totalItems > 0 && <span className="cart-count">{totalItems}</span>}
              </Link>
            </li>
          </ul>
        </nav>
      </div>
    </header>
  );
};

export default Header;
